/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_10_DInputs */

const en_tut_gl_10_d = /** @type {(inputs: Tut_Gl_10_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One room inside the office map — lobby, team area, meeting room, focus zone, or lounge — with its own access rules.`)
};

const id_tut_gl_10_d = /** @type {(inputs: Tut_Gl_10_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu ruang di dalam peta kantor — lobi, area tim, ruang rapat, zona fokus, atau lounge — dengan aturan akses sendiri.`)
};

/**
* | output |
* | --- |
* | "One room inside the office map — lobby, team area, meeting room, focus zone, or lounge — with its own access rules." |
*
* @param {Tut_Gl_10_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_10_d = /** @type {((inputs?: Tut_Gl_10_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_10_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_10_d(inputs)
	return en_tut_gl_10_d(inputs)
});